import React from "react";
import SelectWithClear from "Components/UI/Form/SelectWithClear";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

export default function AgreementLevel({
  client,
  services,
  handleInputChange,
  boolOptions,
}) {
  const templateType = [
    { Name: "-", Value: "0", Category: "templateType" },
    { Name: "Swesum", Value: "1", Category: "templateType" },
  ];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={4}>
        <FormControl fullWidth margin="dense" sx={{ textAlign: "left" }}>
          <SelectWithClear
            name="DefaultService"
            value={client?.DefaultService}
            disabled
            onChange={(e) =>
              handleInputChange("DefaultService", e.target.value)
            }
            label="Förvald tjänst"
          >
            {services?.map((paymentmethod) => (
              <MenuItem key={paymentmethod.Value} value={paymentmethod.Value}>
                {paymentmethod.Name}
              </MenuItem>
            ))}
          </SelectWithClear>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <FormControl margin="dense" fullWidth sx={{ textAlign: "left" }}>
          <InputLabel>Klientmall typ</InputLabel>
          <Select
            name="Template"
            disabled
            value={client?.Template}
            onChange={(e) => handleInputChange("Template", e.target.value)}
            label="Klientmall typ"
            size="small"
          >
            {templateType?.map((type) => (
              <MenuItem key={type.Value} value={type.Value}>
                {type.Name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="PurchaseDirectPaymentPercentage"
          label="Direktbetalning %"
          disabled
          value={client.PurchaseDirectPaymentPercentage}
          onChange={(e) =>
            handleInputChange("PurchaseDirectPaymentPercentage", e.target.value)
          }
          type="number"
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="PurchaseCreditFeePercentage"
          label="Kreditavgift %"
          disabled
          value={client?.PurchaseCreditFeePercentage}
          onChange={(e) =>
            handleInputChange("PurchaseCreditFeePercentage", e.target.value)
          }
          type="number"
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          disabled
          name="CreditFees"
          label="Kreditavgifter %"
          value={client.CreditFees}
          // onChange={(e) =>
          //   handleInputChange("CreditFees", e.target.value)
          // }
          type="number"
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="ServiceFee"
          label="Administrationsavgift SEK"
          disabled
          value={client?.ServiceFee}
          onChange={(e) => handleInputChange("ServiceFee", e.target.value)}
          type="number"
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="MaxCredit"
          label="Max Kredit"
          value={client.MaxCredit}
          disabled
          onChange={(e) => handleInputChange("MaxCredit", e.target.value)}
          type="number"
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <FormControl margin="dense" fullWidth sx={{ textAlign: "left" }}>
          <InputLabel>Regress utförs</InputLabel>
          <Select
            name="Regress"
            value={client.Regress}
            onChange={(e) => handleInputChange("Regress", e.target.value)}
            label="Regress utförs"
            size="small"
            disabled
          >
            {boolOptions?.map((option) => (
              <MenuItem key={option.OptionId} value={option.Value}>
                {option.Name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
}
